import { Box, Header, Text } from '@rbilabs/universal-components';

export const AdditionalInformation = Box.withConfig({
  marginTop: '$2',
  marginBottom: '$7',
  alignItems: 'center',
  _text: {
    color: Styles.color.primary,
    fontSize: 'md',
  },
});

export const DeliveryLogoContainer = Box.withConfig({
  width: '$40',
  marginTop: '$12',
  marginX: 'auto',
  marginBottom: '0',
});

export const LoadingText = Text.withConfig({
  margin: '0',
  fontWeight: 'black',
  textAlign: 'center',
  fontSize: 'md',
  lineHeight: 'md',
});

export const ButtonContainer = Box.withConfig({
  marginTop: '$4',
  width: {
    base: 'full',
    md: '50%',
  },
});

export const NewAddressModalHeading = Box.withConfig({
  marginTop: '$12',
  marginBottom: '$2',
  marginX: '0',
  width: 'full',
  maxWidth: 'full',
});

export const DeliveryInfoContainer = Box.withConfig({
  marginBottom: '$4',
  alignSelf: 'center',
});

export const ModalTitle = Header.withConfig({
  variant: 'hero',
  paddingTop: '$5',
  paddingBottom: '$3',
  textAlign: 'center',
});
